import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-checkbox',
  templateUrl: './checkbox-form-field.component.html',
  styleUrls: ['./checkbox-form-field.component.scss'],
  standalone: false,
})
export class CheckboxFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  ngOnDestroy() {}

  ngOnInit(): void {
    if (this.data == null) {
      this.data = false;
    }
    this.data = this.data === null || this.data === undefined ? false : this.data;
    if (this.formGroup && this.formGroup.get(this.fieldConfig.name)) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.data);
    }
  }
}
